import { connect } from 'react-redux'
import BoardDefsEditor from './components/BoardDefsEditor'
import { editorLoad, editorUpdateDefs, editorSetCurrentBoard, editorLoadDefsList } from '../../store/editor'

const isBoardsLoaded = (state) => {
  return state && state.editor && state.editor.boardDefs
}

const mapStateToProps = (state, ownProps) => {
  return isBoardsLoaded(state)
    ? {
      isLoaded: true,
      currentBoard: state.editor.currentBoard,
      boardDefsList: state.editor.boardDefsList,
      boardDefs: state.editor.boardDefs,
      userInfo: state.userInfo
    }
    : { isLoaded: false }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadEditorData: () => {
    dispatch(editorLoad())
  },
  updateBoardDefs: (newDefs) => {
    dispatch(editorUpdateDefs(newDefs))
  },
  setCurrentBoard: board => {
    dispatch(editorSetCurrentBoard(board))
  },
  loadDefsList: defsList => {
    dispatch(editorLoadDefsList(defsList))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(BoardDefsEditor)



// WEBPACK FOOTER //
// ./src/routes/BoardDefsEditor/index.js